module.exports = __webpack_public_path__ + "static/media/i_featured_online.8be69dbf.svg";